/**
 * Backend error message translations.
 * Maps French error strings from the backend to translation keys.
 * The frontend translates these based on the user's language.
 */

const errorTranslations = {
  fr: {
    // These are already in French (from backend), so just map to themselves
  },
  en: {
    'Accès admin requis': 'Admin access required',
    'Accès client requis': 'Client access required',
    'Accès refusé à cette commande': 'Access denied to this order',
    'Accès refusé à cette réparation': 'Access denied to this repair',
    'Accès refusé': 'Access denied',
    'Accès staff requis': 'Staff access required',
    'Acompte non trouvé': 'Deposit not found',
    'Adresse de livraison obligatoire': 'Delivery address required',
    'Adresse non valide': 'Invalid address',
    'Appareil introuvable': 'Device not found',
    'Appareil non trouvé': 'Device not found',
    'Article non trouvé': 'Item not found',
    'Articles introuvables': 'Items not found',
    'Aucun article sélectionné': 'No item selected',
    'Aucun client sélectionné': 'No client selected',
    'Aucun montant à payer pour cette réparation': 'No amount to pay for this repair',
    'Aucun mot de passe généré. Générez d\'abord un code PIN.': 'No password generated. Generate a PIN code first.',
    'Aucune caisse ouverte': 'No register open',
    'Aucune commande sélectionnée': 'No order selected',
    'Aucune facture active pour cette réparation': 'No active invoice for this repair',
    'Aucune preuve de paiement': 'No payment proof',
    'Body invalide': 'Invalid request body',
    'Bon de commande non trouvé': 'Purchase order not found',
    'Caisse déjà ouverte aujourd\'hui': 'Register already opened today',
    'Caisse déjà validée aujourd\'hui': 'Register already validated today',
    'Caisse fermée. Ouvrez la caisse pour effectuer des ventes.': 'Register closed. Open the register to make sales.',
    'Caisse non trouvée ou déjà fermée': 'Register not found or already closed',
    'Caisse non trouvée': 'Register not found',
    'Ce client n\'a pas d\'adresse email': 'This client has no email address',
    'Ce devis a déjà été traité': 'This quote has already been processed',
    'Ce devis n\'est pas accepté': 'This quote is not accepted',
    'Ce devis n\'est pas en attente de validation': 'This quote is not awaiting validation',
    'Ce devis ne peut plus être modifié': 'This quote can no longer be modified',
    'Ce lien a expiré. Veuillez faire une nouvelle demande.': 'This link has expired. Please make a new request.',
    'Ce nom d\'utilisateur existe déjà': 'This username already exists',
    'Ce numéro a déjà un compte': 'This number already has an account',
    'Cet appareil n\'est pas une demande en ligne': 'This device is not an online request',
    'Cette facture est déjà entièrement payée': 'This invoice is already fully paid',
    'Cette réparation n\'est pas en attente de réception': 'This repair is not awaiting reception',
    'Client avec ce téléphone existe déjà': 'Client with this phone already exists',
    'Client introuvable': 'Client not found',
    'Client non trouvé': 'Client not found',
    'Code administrateur invalide': 'Invalid administrator code',
    'Code de confirmation incorrect': 'Incorrect confirmation code',
    'Code de validation incorrect': 'Incorrect validation code',
    'Commande boutique non trouvée': 'Shop order not found',
    'Commande introuvable': 'Order not found',
    'Commande non trouvée': 'Order not found',
    'Confirmation CB requise': 'Card confirmation required',
    'Date caisse invalide': 'Invalid register date',
    'Demande non trouvée': 'Request not found',
    'Devis non trouvé': 'Quote not found',
    'Document introuvable': 'Document not found',
    'Document non trouvé': 'Document not found',
    'Désignation requise': 'Description required',
    'Email client manquant': 'Client email missing',
    'Email client obligatoire': 'Client email required',
    'Email entreprise non disponible': 'Company email not available',
    'Email invalide': 'Invalid email',
    'Entreprise non trouvée': 'Company not found',
    'Erreur lors de l\'envoi de l\'email': 'Error sending email',
    'Erreur lors de l\'envoi de l\'email. Veuillez réessayer.': 'Error sending email. Please try again.',
    'Facture non trouvée ou annulée': 'Invoice not found or cancelled',
    'Facture non trouvee ou annulee': 'Invoice not found or cancelled',
    'Facture non trouvée': 'Invoice not found',
    'Fichier expiré ou supprimé': 'File expired or deleted',
    'Fichier introuvable': 'File not found',
    'Fichier non trouvé sur le serveur': 'File not found on server',
    'Fichier non trouvé': 'File not found',
    'Forbidden': 'Forbidden',
    'Format KBIS invalide (PDF ou image requis)': 'Invalid KBIS format (PDF or image required)',
    'Format mois invalide': 'Invalid month format',
    'Identifiants incorrects': 'Invalid credentials',
    'Impossible d\'annuler un paiement déjà appliqué': 'Cannot cancel an already applied payment',
    'Impossible de supprimer votre propre compte': 'Cannot delete your own account',
    'Le mot de passe doit contenir au moins 4 caractères': 'Password must be at least 4 characters',
    'Lien de réinitialisation invalide ou déjà utilisé': 'Invalid or already used reset link',
    'Livraison uniquement en Guyane française': 'Delivery only in French Guiana',
    'Marque non trouvée': 'Brand not found',
    'Message vide': 'Empty message',
    'Mode de paiement non autorisé': 'Payment method not allowed',
    'Montant d\'ouverture requis': 'Opening amount required',
    'Montant de la facture invalide': 'Invalid invoice amount',
    'Montant invalide': 'Invalid amount',
    'Mot de passe requis': 'Password required',
    'Nom client obligatoire': 'Client name required',
    'Nom d\'utilisateur déjà pris': 'Username already taken',
    'Nom de marque requis': 'Brand name required',
    'Note introuvable': 'Note not found',
    'Note non trouvée': 'Note not found',
    'Numéro SIRET invalide (14 chiffres requis)': 'Invalid SIRET number (14 digits required)',
    'Paiement introuvable': 'Payment not found',
    'Photo non trouvée': 'Photo not found',
    'Preuve introuvable': 'Proof not found',
    'Produit introuvable': 'Product not found',
    'Profil client non trouvé': 'Client profile not found',
    'Reparation non trouvee': 'Repair not found',
    'Référence déjà existante': 'Reference already exists',
    'Réparation B2B non trouvée': 'B2B repair not found',
    'Réparation non trouvée': 'Repair not found',
    'Réponse Stripe invalide': 'Invalid Stripe response',
    'Réponse vide': 'Empty response',
    'Réservé aux clients': 'Reserved for clients',
    'Seul un administrateur peut modifier le statut après livraison': 'Only an administrator can change status after delivery',
    'Seuls les devis peuvent être convertis en commande': 'Only quotes can be converted to orders',
    'Signature invalide': 'Invalid signature',
    'Token invalide': 'Invalid token',
    'Type d\'utilisateur invalide': 'Invalid user type',
    'Un administrateur existe déjà. Configuration impossible.': 'An administrator already exists. Setup not possible.',
    'Un compte avec cet email existe déjà': 'An account with this email already exists',
    'Une entreprise avec ce SIRET ou email existe déjà': 'A company with this SIRET or email already exists',
    'Utilisateur non trouvé': 'User not found',
    'Vente non trouve9e': 'Sale not found',
    'Vente non trouvée': 'Sale not found',
    'Votre compte a été refusé. Contactez-nous pour plus d\'informations': 'Your account has been refused. Contact us for more information',
    'Votre compte est en attente de validation par notre équipe': 'Your account is awaiting validation by our team',
    'Votre compte est suspendu. Contactez-nous pour plus d\'informations': 'Your account is suspended. Contact us for more information',
    'Vous ne pouvez pas revenir à un statut précédent': 'You cannot revert to a previous status',
  },
  es: {
    'Accès refusé': 'Acceso denegado',
    'Identifiants incorrects': 'Credenciales incorrectas',
    'Devis non trouvé': 'Presupuesto no encontrado',
    'Facture non trouvée': 'Factura no encontrada',
    'Client non trouvé': 'Cliente no encontrado',
    'Réparation non trouvée': 'Reparacion no encontrada',
    'Aucune caisse ouverte': 'Ninguna caja abierta',
    'Caisse fermée. Ouvrez la caisse pour effectuer des ventes.': 'Caja cerrada. Abra la caja para realizar ventas.',
    'Email invalide': 'Email invalido',
    'Montant invalide': 'Monto invalido',
    'Utilisateur non trouvé': 'Usuario no encontrado',
    'Token invalide': 'Token invalido',
    'Forbidden': 'Prohibido',
  },
  pt: {
    'Accès refusé': 'Acesso negado',
    'Identifiants incorrects': 'Credenciais incorretas',
    'Devis non trouvé': 'Orcamento nao encontrado',
    'Client non trouvé': 'Cliente nao encontrado',
    'Aucune caisse ouverte': 'Nenhuma caixa aberta',
    'Email invalide': 'Email invalido',
    'Utilisateur non trouvé': 'Utilizador nao encontrado',
    'Token invalide': 'Token invalido',
    'Forbidden': 'Proibido',
  },
  ru: {
    'Accès refusé': 'Доступ запрещен',
    'Identifiants incorrects': 'Неверные данные для входа',
    'Devis non trouvé': 'Смета не найдена',
    'Client non trouvé': 'Клиент не найден',
    'Aucune caisse ouverte': 'Нет открытой кассы',
    'Email invalide': 'Неверный email',
    'Utilisateur non trouvé': 'Пользователь не найден',
    'Token invalide': 'Недействительный токен',
    'Forbidden': 'Запрещено',
  },
  ar: {
    'Accès refusé': 'تم رفض الوصول',
    'Identifiants incorrects': 'بيانات دخول غير صحيحة',
    'Devis non trouvé': 'عرض السعر غير موجود',
    'Client non trouvé': 'العميل غير موجود',
    'Aucune caisse ouverte': 'لا يوجد صندوق مفتوح',
    'Email invalide': 'بريد إلكتروني غير صالح',
    'Utilisateur non trouvé': 'المستخدم غير موجود',
    'Token invalide': 'رمز غير صالح',
    'Forbidden': 'محظور',
  },
  zh: {
    'Accès refusé': '访问被拒绝',
    'Identifiants incorrects': '登录信息错误',
    'Devis non trouvé': '报价未找到',
    'Client non trouvé': '客户未找到',
    'Aucune caisse ouverte': '没有已开启的收银台',
    'Email invalide': '邮箱无效',
    'Utilisateur non trouvé': '用户未找到',
    'Token invalide': '无效令牌',
    'Forbidden': '禁止访问',
  },
};

/**
 * Translate a backend error message to the user's language.
 * Falls back to the original French message if no translation exists.
 * @param {string} message - The error message from the backend (in French)
 * @param {string} lang - The current language code
 * @returns {string} - The translated error message
 */
export function translateError(message, lang) {
  if (!message) return '';

  // French is the backend's native language, return as-is
  if (lang === 'fr') return message;

  // Base-language fallback chain: pt-BR -> pt, ar-SY -> ar, zh-CN -> zh, then English, then original.
  // (These base maps exist; the regional maps do not, so we degrade to the base language, not straight to EN.)
  const base = String(lang || '').split('-')[0];
  const candidates = [lang, base, 'en'];
  for (const code of candidates) {
    const map = errorTranslations[code];
    if (map && map[message]) return map[message];
  }

  // No translation found, return original message
  return message;
}

export default errorTranslations;
